import myZjs from "@/pages/zj_select/index.vue";
export default {
    components: { myZjs },
    data() {
        return {
            datetime: '',
            timer: 0,
            yss: [],
            show_ys_zjs: false,
            add_zj: {},
            citys: [],
            city: '',
            show_sd: false,
            zjs: [],
            show_zj: false,
            is_zj_info: false,
            zj_info: {
                js: 0,
                jj: 0
            },
            table: 'ps',
            datas: {
                add: {
                }
            },
            r: {
                dl_name: '',
                call: '',
                dw: '',
                name: '',
                call: '',
                dl_admin: {},
                js_admin: {}
            },
            ys: {}
        };
    },
    computed: {
        disabled() {
            if (!this.r.id) {
                return false;
            }
            if (this.vuex_admin.admin_group_id == 1) {
                return false;
            }
            if (this.r.admin_id == this.vuex_admin.id) {
                return false;
            }
            return true;
        }
    },
    watch: {
        'r.admin_dl'(val) {
            if (val) {
                this._zj_info(val);
            } else {
                this._reset('zj_info')
            }
        }
    },
    created() {
        this._dls();
        this._admin().then(res => {
            console.log(res);
            if (res.data.admin_group_id == 3) {
                this._zj_info(res.data.id);
            }
        });
        this._admins([2, 3]);
        this._load();
        this._citys();
    },
    beforeDestroy() {
        clearTimeout(this.timer);
    },
    methods: {
        _get_time() {
            // 创建一个新的 Date 对象，表示当前日期和时间
            const now = new Date();
            // 获取年、月、日、时、分、秒
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并且补零到两位数
            const day = String(now.getDate()).padStart(2, '0'); // 日期并补零到两位数
            const hours = String(now.getHours()).padStart(2, '0'); // 小时并补零到两位数
            const minutes = String(now.getMinutes()).padStart(2, '0'); // 分钟并补零到两位数
            const seconds = String(now.getSeconds()).padStart(2, '0'); // 秒并补零到两位数
            // 格式化输出
            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            console.log(formattedDate);
            this.datetime = formattedDate;
        },
        _sx_zjs() {
            let _this = this;
            let runTimer = () => {
                console.log(1);
                if (!this.show_zj) {
                    return;
                }
                _this._get_zjs();
                // 
                clearTimeout(this.timer);
                this.timer = setTimeout(runTimer, 10000);
            };
            runTimer();
        },
        _do_yss() {
            this.r.yss = this.r.yss.filter(item => {
                return item.name && item.phone && item.type;
            });
            this.$http.post('ps/edit', {
                ...this.r
            }).then(res => {
                if (res.code) {
                    this.show_ys_zjs = false;
                    this._reset('r');
                    this._load();
                }
            })
        },
        _row_click(data) {
            let index = this.r.yss.findIndex(item => {
                return item.phone == data.phone;
            });
            if (index >= 0) {
                this._msg('专家手机号已存在', 0);
            } else {
                this.r.yss.push({
                    name: data.name,
                    sfz: data.sfz,
                    phone: data.phone,
                    type: data.type,
                });
            }
        },
        _ys_zjs(data) {
            if (this.vuex_admin.admin_group_id == 1 || this.vuex_admin.is_ys) {
                this.$http.post('ps/show', {
                    id: data.id
                }).then(res => {
                    if (res.code) {
                        this.r = res.data;
                        this.show_ys_zjs = true;
                    }
                })
            }
        },
        _citys() {
            this.$http.post('city/list', {
                limit: 1000
            }).then(res => {
                if (res.code) {
                    this.citys = res.data.data;
                }
            })
        },
        _add_zj() {
            this.$http.post('ps/add_zj', {
                ps_id: this.r.id,
                ...this.add_zj
            }).then(res => {
                if (res.code) {
                    this.show_sd = false;
                    this._reset('add_zj')
                    this._get_zjs();
                }
            })
        },
        _get_zjs() {
            this.$http.post('ps/zjs', {
                id: this.r.id
            }).then(res => {
                if (res.code) {
                    this.zjs = res.data;
                }
            })
        },
        _chouq_zj() {
            this.$http.post('ps/chouq_zj', {
                id: this.r.id,
                city: this.city
            }).then(res => {
                if (res.code) {
                    this.r.cq_num++;
                    this._get_zjs();
                }
            })
        },
        _down_excel(id) {
            this.$http.post('ps/excels', {
                id,
            }, {
                responseType: 'blob',
            }).then(res => {
                const file = new Blob([res], { type: 'application/xlsx' });
                // 创建一个指向Blob的URL
                const fileURL = URL.createObjectURL(file);
                // 创建一个临时的a标签用于下载
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'download.xlsx'); // 设定下载文件名
                document.body.appendChild(fileLink);
                // 模拟点击a标签以触发下载
                fileLink.click();
                // 清理
                document.body.removeChild(fileLink);
                URL.revokeObjectURL(fileURL); // 释放内存中的URL对象
            })
        },
        _zj(id) {
            this._get_time();
            this.$http.post('ps/show', {
                id,
                append: ['dl_admin', 'js_admin']
            }).then(res => {
                if (res.code) {
                    this.r = res.data;
                    this.$http.post('ps/zjs', {
                        id
                    }).then(res => {
                        if (res.code) {
                            this.zjs = res.data;
                            this.show_zj = true;
                            this._sx_zjs();
                        }
                    })
                }
            })
        },
        _submit() {
            if (this.r.js_num > this.zj_info.js) {
                this._msg('技术类专家不足', 0);
                return;
            }
            if (this.r.jj_num > this.zj_info.jj) {
                this._msg('经济类专家不足', 0);
                return;
            }
            this.$http.post(`${this.table}/${this.r.id ? 'edit' : 'add'}`, {
                ...this.r
            })
                .then(res => {
                    if (res.code) {
                        this.show_save = false;
                        this.r = this.$options.data().r;
                        this._load(1);
                    }
                });
        },
        _zj_info(admin_dl) {
            this.$http.post('zj/info', {
                admin_dl
            }).then(res => {
                if (res.code) {
                    this.zj_info = res.data;
                    this.is_zj_info = true;
                }
            })
        },
        _set_js(id) {
            this.$http.post('admin/show', {
                id
            }).then(res => {
                if (res.code) {
                    this.r.name = res.data.name;
                    this.r.call = res.data.call;
                }
            })
        },
        _set_dl(id) {
            this.$http.post('admin/show', {
                id
            }).then(res => {
                if (res.code) {
                    this.r.dl_name = res.data.name;
                    this.r.dl_call = res.data.call;
                }
            })
        },
        _dls() {
            this.$http.post('admin/list', {
                admin_group_id: 4
            }).then(res => {
                if (res.code) {
                    this.dls = res.data.data;
                }
            })
        },
    },
};